import styles from './radio.module.scss';

interface OwnProps {
    disabled: boolean;
    defaultChecked: boolean;
    name: string;
    label: string;
}

export function Radio({disabled, defaultChecked, name, label}: OwnProps) {
    return (
        <div className={styles.radio}>
            <input id={name} type="radio" name={name} disabled={disabled} defaultChecked={defaultChecked} />
            <label htmlFor={name}>{label}</label>
        </div>
    );
}
